App.controller('ZochLifeInsuranceListCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaLifeInsuranceService', 'zochaNavigationService', '$timeout', '$stateParams', 'Blob', 'FileSaver', '$filter', 'popUpService', '$rootScope', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaLifeInsuranceService, zochaNavigationService, $timeout, $stateParams, Blob, FileSaver, $filter, popUpService, $rootScope) {
    $scope.stateParams = $stateParams;
    $scope.page = 'zoch_insurance';
    $scope.$emit('page', $scope.page);
    $scope.cantDeduct = false;

    if ($scope.stateParams.user) {
        $scope.userId = $scope.stateParams.user.id;
        $scope.who = $scope.stateParams.user.person.firstName + ' ' + $scope.stateParams.user.person.lastName;
    } else {
        $scope.userId = '';
        $scope.who = '';
    }

    $scope.step = 'Zarządzaj deklaracjami - Ubezpieczenie na życie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.dictionary = {};

    var page = 0;
    $scope.status = 'all';
    $scope.current = page;
    $scope.pageSize = 10;
    $scope.searchString = '';


    loadActivities(page);
    prepareDictionaryListPerRights();

    $scope.search = function () {
        loadActivities(0, $scope.status);
    };

    $scope.byStatus = function (status) {
        loadActivities(0, status);
    };

    $scope.pageChanged = function (page) {
        loadActivities(page, $scope.status);
        $scope.current = page;
    };

    $scope.loadAll = function () {
        $scope.userId = '';
        $scope.who = '';
        $scope.status = 'all';
        $scope.current = 0;
        $scope.searchString = '';
        loadActivities(0, 'all');
    };

    function prepareDictionaryListPerRights() {
        $scope.dictionary = {
            "ENTERED": "wprowadzony",
            "EXPIRED": "wygaszony",
            "DELETED": "usunięty",
            "READY": "zawarty",
            "ACTIVE": "aktywny",
            "CANCELED": "anulowany",
            "WITHDRAWN": "wystąpienie",
            "ENDED": "zakończony"
        };

        if (!$filter('prepareRights')('ADMIN')) {
           delete $scope.dictionary['EXPIRED'];
        }
    }

    function loadActivities(page, status) {
        var criteria = {
            pageNumber: page,
            pageSize: $scope.pageSize,
            userId: $scope.userId,
            search: $scope.searchString
        };

        if ($scope.cantDeduct) {
            criteria.cantDeduct = $scope.cantDeduct;
        }

        if (status && status !== 'all') {
            criteria.status = status;
        }

        zochaLifeInsuranceService.dataList(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.activities = data.data.data;
                for (var a = 0; a < $scope.activities.length; a++) {
                    $scope.activities[a].activeStatus = ($scope.activities[a].status === 'ACTIVE') ? true : false;
                }
                $scope.numberOfPages = data.data.pages;
                // $scope.buildScroll();
            }
        });
    }

    $scope.changeStatus = function (id, value) {
        if (value) {
            zochaLifeInsuranceService.originalCopyEntered(id).then(function (data) {
                if (data.status === 200) {
                    loadActivities($scope.current);
                }
            });
        }
    };

    $scope.active = function (id, value) {
        if (value) {
            zochaLifeInsuranceService.active(id).then(function (data) {
                if (data.status === 200) {
                    loadActivities($scope.current);
                }
            });
        }
    };

    $scope.getDeclaration = function (value) {
        var id = value.id, barcode = value.barcode;

        zochaLifeInsuranceService.getDeclaration(id).then(function (data) {
            if (data.status === 200) {
                var data = new Blob([data.data], {type: 'application/pdf'});
                FileSaver.saveAs(data, 'Deklaracja_' + barcode + '.pdf');
            }
        });
    };

    $scope.uploadDeclaration = function (id) {
        var vm = this;

        if (!vm.uploadDeclarationForm.$valid) {
            return 0;
        }

        zochaLifeInsuranceService.enterOriginalCopyBarcode(id).then(function (data) {
            console.log(data);
            if (data.status === 200) {
                if (!data.data.replacedDeclaration) {
                    $scope.showPopUp('', '', 'Dostarczenie dokumentu nr ' + id + ' zostało oznaczone poprawnie w systemie', '', '', true);
                } else {
                    $scope.showPopUp('', '', 'Dostarczony dokument nr ' + id + ' zastępuje w systemie dokument nr ' + data.data.replacedDeclaration.barcode + '. Zmiany będą obowiązywać od ' + $filter('dateFormatter')(data.data.replacedDeclaration.endDateBasedOnWithdrawalDate), '', '', true);
                }
            } else if (data.data.message === 'DeclatrationNotExistsException') {
                popUpService.showPopUpWithError(data.data, {ev: '', head: '', content: 'W systemie nie istnieje podany numer deklaracji. W celu wyjaśnienia sytuacji, skontaktuj się z administratorem.', text: '', target: '', reload: false});
            } else if (data.data.message === 'OriginalCopyAlreadyEnteredException') {
                popUpService.showPopUpWithError(data.data, {ev: '', head: '', content: 'W systemie jest już oznaczone dostarczenie oryginału dokumentu.', text: '', target: '', reload: false});
            } else if (data.data.message === 'WrongStatusException') {
                popUpService.showPopUpWithError(data.data, {ev: '', head:'', content: 'Wskazana deklaracja jest nieaktywna! Nie można jej już aktywować. W celu wyjaśnienia sytuacji, skontaktuj się z administratorem.', text: '', target: '', reload: false});
            }
        });
    };

    $scope.showPopUp = function (ev, head, content, text, target, reload) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-small.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                reload: reload,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {

        }, function () {

        });
    };

    function PopUpInfoCtrl($scope, $mdDialog, locals, $state) {
        $scope.locals = locals;

        $scope.hide = function () {
            if ($scope.locals.reload) {
                $state.reload();
            }
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            if ($scope.locals.reload) {
                $state.reload();
            }
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            if ($scope.locals.reload) {
                $state.reload();
            }
            $mdDialog.hide($scope.locals);
        };
    }

    $scope.buildScroll = function () {
        $timeout(function () {
            scrollbarHorizontalMenu('.activitylist .scroll');
        }, 1);
    };

    function scrollbarHorizontalMenu(el) {
        $(el).mCustomScrollbar({
            axis: "x",
            theme: "dark-thin",
            autoHideScrollbar: true,
            scrollbarPosition: "outside",
            advanced: {autoExpandHorizontalScroll: true},
            callbacks: {
                onInit: function () {

                },
                onScroll: function () {

                }
            }
        });
    }

    $scope.goToWorkerDetails = function (value) {
        zochaNavigationService.goToWorkerDetails(value.declaration.userId);
    };

    $scope.filterCantDeduct = function () {
        loadActivities(0, $scope.status);
    };
}]);
